import React from 'react'
import productListInformationFragment from '@data/fragments/products/productListInformation'
import hasWebpSupport from '@helpers/misc/hasWebpSupport'
import useDebounce from '@hooks/useDebounce'
import useWebsiteId from '@hooks/useWebsiteId'
import {useApolloQuery} from '@packages/apollo-hooks'
import Product from '@page-components/Order/Products/ProductsContent/Category/Product'
import gql from 'graphql-tag'

import ProductsLoading from '../../Loading/Products'

import {
  getCategoriesLayoutProductSearchResults_cached,
  getCategoriesLayoutProductSearchResults_cachedVariables
} from './__generated__/getCategoriesLayoutProductSearchResults_cached'
import NoResults from './NoResults'
import useSetOutOfStockProducts from './useSetOutOfStockProducts'

import styles from './styles.module.css'

const format = hasWebpSupport() ? 'webp' : 'jpeg'

export default function Products(props) {
  const {filter, storeId, deliverAt, menuId} = props
  const websiteId = useWebsiteId()
  const [debouncedFilter, debouncedLoading] = useDebounce(filter, 500)
  const {products, loading} = useApolloQuery<
    getCategoriesLayoutProductSearchResults_cachedVariables,
    getCategoriesLayoutProductSearchResults_cached
  >({
    query: gql`
      query getCategoriesLayoutProductSearchResults_cached(
        $websiteId: ID
        $filter: String
        $menuId: ID
        $format: String
      ) {
        products: searchProducts(filter: $filter, websiteId: $websiteId, menuId: $menuId) {
          _id
          ...productListInformation
        }
      }
      ${productListInformationFragment}
    `,
    variables: {
      websiteId,
      filter: debouncedFilter,
      menuId
    },
    partial: true
  })

  const {outOfStockIds} = useSetOutOfStockProducts({websiteId, products, deliverAt, storeId})

  if (loading || debouncedLoading || !products) return <ProductsLoading />

  if (!products.length) return <NoResults />

  return (
    <div className={styles.container}>
      {products.map(product => {
        product.isOutOfStock = outOfStockIds?.includes(product._id)
        return (
          <div className="col-xs-4 col-sm-3 col-md-2 col-lg-2" key={product._id}>
            {/* @ts-expect-error ts-migrate(2739) FIXME: Type 'getCategoriesLayoutProductSearchResults_cach... Remove this comment to see the full error message */}
            <Product product={product} productsLayout="compact" menuId={menuId} />
          </div>
        )
      })}
    </div>
  )
}
